import { Feature } from "ol";
import { getCenter } from "ol/extent";
import { Point } from "ol/geom";
import { Icon, Style } from "ol/style";
import { ClientLayer } from "../../../lib/layers";
import { Maybe } from "../../../lib/misc/option";
export class MarkerLayer extends ClientLayer {
    constructor(parcel_layer) {
        super();
        this.parcel_layer = parcel_layer;
        this.name = "MapMarkers";
        this.raw.setStyle(new Style({
            image: new Icon({
                anchor: [0.5, 1],
                opacity: 1.0,
                scale: 0.05,
                src: '../../../../../../img/gis/map-marker-icon.png'
            })
        }));
    }
    get markers() {
        return this.source.getFeatures();
    }
    get selected() {
        return this.markers.map(m => m.get('strap'));
    }
    findMarkerByStrap(strap) {
        return this.markers.find(m => m.get('strap') === strap || m.get('gis_strap') === strap);
    }
    has_marker_for_strap(strap) {
        return !!this.findMarkerByStrap(strap);
    }
    toggle_marker_at_parcel(strap) {
        if (this.has_marker_for_strap(strap))
            this.remove_marker_from_parcel(strap);
        else
            this.add_marker_to_parcel(strap);
        this.changed();
    }
    async add_marker_to_parcel(inputStrap) {
        if (this.has_marker_for_strap(inputStrap))
            return;
        if (!this.parcel_layer.ids.includes(inputStrap))
            return;
        const parcel = await this.parcel_layer.get_feature_by_id(inputStrap);
        const parcelId = parcel.map(p => p.get(this.parcel_layer.identifier)).unwrapOr(inputStrap);
        parcel.flatmap(p => Maybe(p.getGeometry()))
            .map(poly => poly.getExtent())
            .map(e => getCenter(e))
            .map(c => new Point(c))
            .map(pt => new Feature({ geometry: pt, type: 'marker', strap: parcelId, gis_strap: inputStrap }))
            .map(f => this.source.addFeature(f));
    }
    remove_marker_from_parcel(strap) {
        const marker = this.findMarkerByStrap(strap);
        if (!marker)
            return;
        this.source.removeFeature(marker);
    }
}
